import React, {memo, useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import DropDown, {OptionsAlign} from "../DropDown/DropDown";
import {themeColors} from "../../styles/theme";
import {useTypedSelector} from "../../redux/Hooks/storeSelectors";
import {selectRunIdToCompareWith} from "../../redux/selectors/selectors";
import {Run, usePresetsContext} from "../../context/presetsContext";
import {Box} from "@mui/material";
import CheckboxField from "../form/CheckboxField/CheckboxField";
import './run-to-compare-with-selector.scss';
import {setRunIdToCompareWith} from "../../redux/reducers/projectsReducer";
import {isUuidString} from "../../utils/utils";
import Tooltip from "@mui/material/Tooltip";


const RunsToCompareSelector = memo(({label}: { label: string; }) => {
    const [enabledComparison, setEnabledComparison] = useState<boolean>(false);
    const {selectedRunId, runs} = usePresetsContext();
    const runIdToCompareWith = useTypedSelector(selectRunIdToCompareWith);
    const {t} = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        setEnabledComparison(false);

        return () => {
            dispatch(setRunIdToCompareWith());
        }
    }, [selectedRunId]);

    const runOptions: Run[] = useMemo(() => runs.filter(({id}) => id !== selectedRunId).map(run => ({
        ...run,
        onClick: () => dispatch(setRunIdToCompareWith(run.id))
    })), [selectedRunId, runs]);

    const selectedRunIndex = isUuidString(runIdToCompareWith) ? runOptions.findIndex(({id}) => id === runIdToCompareWith) : 0;

    const checkboxClickHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const {checked} = event.target;
        const {id} = runOptions?.[selectedRunIndex] ?? {};

        setEnabledComparison(checked);
        dispatch(setRunIdToCompareWith(checked && id ? id : ''));
    }, [runOptions, selectedRunIndex]);

    return (
        <>
            {
                runs.length ?
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            border: `1px solid ${themeColors.grey3}`,
                            borderRadius: 1,
                            padding: '5px'
                        }}
                    >
                        <Tooltip title={label} placement="top">
                            <div className="run-to-compare-with-selector">
                                <CheckboxField
                                    name=""
                                    value={`${enabledComparison}`}
                                    onChange={checkboxClickHandler}
                                    disabled={runOptions.length === 0}
                                />
                                <DropDown
                                    selectedOptionInd={selectedRunIndex}
                                    options={runOptions}
                                    optionsAlign={OptionsAlign.LEFT}
                                    // disabled={allowedModesDontExist}
                                    titleColorLight={themeColors.navyBlue}
                                    titleColorDark={themeColors.white}
                                    optionColorLight={themeColors.navyBlue}
                                    optionColorDark={themeColors.white}
                                    iconColorLight={themeColors.white}
                                    iconColorDark={themeColors.navyBlue}
                                    iconRectangleWidth={35}
                                    tooltip={t('header.select-run')}
                                    disabled={!enabledComparison}
                                    maxWidth="300px"
                                />
                            </div>
                        </Tooltip>
                    </Box>
                    : null
            }
        </>
    )
})

export default RunsToCompareSelector;